<template>
  <div>
    <el-card>
      <div class="wrap-rub">
        <div class="wrap-left">
          <div class="title">
            <img src="https://public-static-edu.codemao.cn/redboat/courseManage/学习目标.png" />
            <h3>学习目标！</h3>
          </div>
          <ul class="content">
            <li v-for="(item, index) in targetList" :key="index">
                <i class="icon el-icon-star-off"></i> &nbsp;
                <span>{{item}}</span>
              </li>
              <li v-if="targetStr">
                <i class="icon el-icon-star-off"></i> &nbsp;
                <span>{{targetStr}}</span>
              </li>
          </ul>
        </div>
      </div>
    </el-card>

    <el-card style="margin-top: 15px;">
      <div class="wrap-left">
        <div class="title">
          <img src="https://public-static-edu.codemao.cn/redboat/courseManage/目标达成.png" />
          <h3>目标达成！</h3>
        </div>
      </div>
      <ul class="text">
        <li>还需努力</li>
        <li>基本掌握</li>
        <li>完全掌握</li>
        <li>超常发挥</li>
      </ul>
      <div class="slider">
        <div class="content">
          <p>知识也疯狂</p>
          <span>（知识理解）</span>
        </div>
        <el-slider v-model="understand" :max="3" :disabled="true" :show-tooltip="false"></el-slider>
      </div>
      <div class="slider">
        <div class="content">
          <p>小试牛刀</p>
          <span>（基础应用）</span>
        </div>
        <el-slider v-model="basic" :max="3" :disabled="true" :show-tooltip="false"></el-slider>
      </div>
      <div class="slider">
        <div class="content">
          <p>驯码高手</p>
          <span>（综合应用）</span>
        </div>
        <el-slider v-model="complex" :max="3" :disabled="true" :show-tooltip="false"></el-slider>
      </div>
    </el-card>
  </div>
</template>

<script>
import { Card, Slider } from 'element-ui'
export default {
  components: {
    'ElCard': Card,
    'ElSlider': Slider
  },
  props: ['data'],
  data () {
    return {
      targetList: [],
      targetStr: '',
      understand: 3,
      basic: 3,
      complex: 3
    }
  },
  watch: {
    'data': {
      handler (val) {
        this.$nextTick(() => {
          // 有换行
          if (!Object.keys(val).length) return
          const data = val.target_finish_level_info
          this.understand = data[0].value - 1
          this.basic = data[1].value - 1
          this.complex = data[2].value - 1
          const str = val.growth_template_info && val.growth_template_info.lesson_target
          if (/[\n\r]/g.test(str)) {
            this.targetList = str.split(/[\n\r]/g).filter(row => row)
          } else {
            this.targetStr = str
          }
        })
      },
      immediate: true
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './view.styl';

.el-card {
  border: 0;
  box-shadow: 0 2px 12px 0 rgba($themeColor, 0.1);
}

.wrap-rub {
  display: flex;

  .content {
    overflow: auto;

    li {
      margin-bottom: 10px;
    }

    .icon {
      color: $themeColor;
      font-size: 14px;
      margin-right: 8px;
    }

    span {
      font-size: 12px;
      word-break: break-all;
    }
  }
}

.text {
  display: flex;
  justify-content: space-between;
  margin: 0 0 18px 78px;

  li {
    transform: rotate(-45deg);
    font-weight: 500;

    &:first-child {
      color: #ff9948;
    }

    &:nth-child(2) {
      color: $themeColor;
    }

    &:nth-child(3) {
      color: #4886ff;
    }

    &:last-child {
      color: #ff4898;
    }
  }
}

.slider {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 10px;

  .el-slider {
    display: contents;

    >>>.el-slider__runway {
      height: 10px;
      background-color: #e5f9f2;
    }

    >>>.el-slider__button {
      border: solid 2px $themeColor;
    }

    >>>.el-slider__bar {
      height: 10px;
      background: url('https://public-static-edu.codemao.cn/redboat/courseManage/矩形.svg');
    }

    >>>.el-slider__button-wrapper {
      opacity: 0;
    }

    >>>.el-slider__runway.disabled, >>>.el-slider__button-wrapper:hover, >>>.hover {
      cursor: default !important;
    }
  }

  .content {
    margin-right: 10px;
    white-space: nowrap;
    text-align: center;
    font-size: 12px;

    p {
      margin-bottom: 0;
    }
  }

  >>>.el-slider__button:hover, .el-slider__button.hover, .el-slider__button.dragging {
    // box-shadow: 0 0 8px 0 rgba(var(--primary-color-source), 0.8);
  }
}
</style>
